import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * WebMCP Provider
 * Exposes core site tools to AI agents via the browser's modelContext API.
 */
export function WebMCPProvider({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if the browser supports WebMCP
    if (typeof window !== "undefined" && (window as any).navigator?.modelContext?.provideContext) {
      try {
        (window as any).navigator.modelContext.provideContext({
          tools: [
            {
              name: "search_library",
              description: "Search for medical resources in the library.",
              inputSchema: {
                type: "object",
                properties: {
                  query: { type: "string", description: "The search keyword or tag" },
                  faculty: { type: "string", description: "Optional faculty filter" }
                },
                required: ["query"]
              },
              execute: async ({ query, faculty }: { query: string; faculty?: string }) => {
                const params = new URLSearchParams();
                params.set("search", query);
                if (faculty) params.set("faculty", faculty);
                navigate(`/library?${params.toString()}`);
                return { success: true, message: `Searching library for "${query}"` };
              }
            },
            {
              name: "open_resource",
              description: "Open a specific resource by its ID.",
              inputSchema: {
                type: "object",
                properties: {
                  id: { type: "string", description: "The resource UUID" }
                },
                required: ["id"]
              },
              execute: async ({ id }: { id: string }) => {
                navigate(`/resource/${id}`);
                return { success: true, message: `Navigating to resource ${id}` };
              }
            },
            {
              name: "view_dashboard",
              description: "Go to the student study dashboard.",
              inputSchema: { type: "object", properties: {} },
              execute: async () => {
                navigate("/student");
                return { success: true, message: "Navigated to dashboard" };
              }
            }
          ]
        });
        console.log("WebMCP tools registered successfully.");
      } catch (err) {
        console.error("Failed to register WebMCP tools:", err);
      }
    }
  }, [navigate]);

  return <>{children}</>;
}
